// extracted by mini-css-extract-plugin
export var boxItems = "_9t-1";
export var boxItemsLg = "_9t-2";
export var button = "_9t-7";
export var buttonHoverless = "_9t-9";
export var buttonLg = "_9t-8";
export var filterGroupBox = "_9t-0";
export var icon = "_9t-3";
export var iconSecondary = "_9t-6";
export var iconWrapper = "_9t-4";
export var iconWrapperLg = "_9t-5";
export var truncatedLabel = "_9t-a";